// On document.ready
$(document).ready(function () {
    toggleMoreContent();
});

function toggleMoreContent()
{
    let contentElements = $("[data-more-content-to-toggle]");
    let toggleButtons = $("[data-more-content-button]");

    contentElements.each(function () {
        let maxHeight = $(this).data('moreContentMaxHeight');
        $(this).css({"max-height": maxHeight, "overflow": "hidden"});
    });

    toggleButtons.on('click', function (e) {
        e.preventDefault();

        let newHeight = 0;
        let target = $("[data-more-content-to-toggle='"+$(this).data('moreContentButton')+"']");
        let maxHeight = target.data('moreContentMaxHeight');
        let buttontxt = $(this).data('moreContentTxt');

        console.log(target, maxHeight, buttontxt);

        if (target.hasClass("active")) {
            newHeight = maxHeight;
            target.removeClass("active");
            $(this).html(buttontxt.show);
        } else {
            newHeight = target[0].scrollHeight;
            target.addClass("active");
            $(this).html(buttontxt.hide);
        }

        target.animate({
            "max-height": newHeight
        }, 100);

        equalHeight();

    });
}
